import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=6a9e4f98&scoped=true&"
import script from "./PersonalInformation.vue?vue&type=script&lang=ts&"
export * from "./PersonalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInformation.vue?vue&type=style&index=0&id=6a9e4f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e4f98",
  null
  
)

export default component.exports